export default __webpack_public_path__ + "static/media/betslips-bg-testure.ae5558f5.png";